import { render, staticRenderFns } from "./RuleFilters.vue?vue&type=template&id=2e1257ca"
import script from "./RuleFilters.vue?vue&type=script&lang=js"
export * from "./RuleFilters.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports